import { render, staticRenderFns } from "./ImportsView.vue?vue&type=template&id=2a9b2a80&scoped=true"
import script from "./ImportsView.vue?vue&type=script&lang=js"
export * from "./ImportsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9b2a80",
  null
  
)

export default component.exports